'use strict';

var $ = require('jquery');

var mobileRefinements = {
    init: function () {
        var $activeDomElements = $('html, .body, .refinements-mobile');
        var $refinementsMobile = $('.refinements-mobile');
        var $refinementsMobileContent = $refinementsMobile.find('.refinements-mobile-content');
        var $parentCategoryLinks = $refinementsMobile.find('.a-level-1');
        var $returnLinks = $refinementsMobile.find('.flyin-close');
        var $flyIns = $refinementsMobile.find('.flyin');
        var $triggerButton = $('.mobile-refinements-trigger');
        var $closeButton = $('.mobile-refinements-close');

        // show mobile refinement by clicking trigger
        $triggerButton.on('click', function (e) {
            e.preventDefault();
            $activeDomElements.addClass('mr-active');
        });

        // hide mobile refinement by clicking button
        $closeButton.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $activeDomElements.removeClass('mr-active');
            $flyIns.removeClass('mrsc-active');
            $refinementsMobileContent.removeClass('mrsc-active');
        });

        // show flyin
        $parentCategoryLinks.on('click', function (e) {
            e.preventDefault();
            $(this).next('.flyin').addClass('mrsc-active');
            $refinementsMobileContent.addClass('mrsc-active');
        });

        // back
        $returnLinks.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).closest('.flyin').removeClass('mrsc-active');
            $refinementsMobileContent.removeClass('mrsc-active');
        });
    }
};

exports.init = mobileRefinements.init;
